import { render } from "./TelemetryFrame.vue?vue&type=template&id=3fa45d0d"
import script from "./TelemetryFrame.vue?vue&type=script&lang=js"
export * from "./TelemetryFrame.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akhenry/Code/openmct-clean/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__